import { Injectable, signal, computed } from '@angular/core';

const SESSION_KEY = 'sbe_session';

export interface SessionInfo {
  accessToken: string;
  userId: number;
  name: string | null;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly _session = signal<SessionInfo | null>(this.loadFromStorage());

  readonly session = this._session.asReadonly();
  readonly isLoggedIn = computed(() => this._session() !== null);

  private loadFromStorage(): SessionInfo | null {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      return raw ? (JSON.parse(raw) as SessionInfo) : null;
    } catch {
      return null;
    }
  }

  setSession(info: SessionInfo): void {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(info));
    this._session.set(info);
  }

  updateAccessToken(accessToken: string): void {
    const current = this._session();
    if (!current) return;
    const updated = { ...current, accessToken };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(updated));
    this._session.set(updated);
  }

  clearSession(): void {
    sessionStorage.removeItem(SESSION_KEY);
    this._session.set(null);
  }

  getToken(): string | null {
    return this._session()?.accessToken ?? null;
  }
}
